import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import moment from "moment";
import { gridConfigs } from "../constants/gridConfigs";
import { GET_REMITOS_BOT } from "../../../data/graphQL/queries/ReporteBOT/getRemitosBOT";
import { GET_AUTORIZACIONES_BOT } from "../../../data/graphQL/queries/ReporteBOT/getAutorizacionesBOT";
import { GET_CONFORMIDADES_BOT } from "../../../data/graphQL/queries/ReporteBOT/getConformidadesBOT";
import toast from "react-hot-toast";

export const useGetRows = (filters, tipoRemitoId, tipoAutorizacionId, setIsRefetchRequired) => {
  const [rows, setRows] = useState([]);

  const [getRemitos, { loading: loadingRemitos, data: dataRemitos }] = useLazyQuery(GET_REMITOS_BOT, {
    fetchPolicy: 'no-cache'
  });
  const [getAutorizaciones, { loading: loadingAutorizaciones, data: dataAutorizaciones }] = useLazyQuery(GET_AUTORIZACIONES_BOT, {
    fetchPolicy: 'no-cache'
  });
  const [getConformidades, { loading: loadingConformidades, data: dataConformidades }] = useLazyQuery(GET_CONFORMIDADES_BOT, {
    fetchPolicy: 'no-cache'
  });

  // Manejar respuesta de Remitos
  useEffect(() => {
    if (dataRemitos) {
      const remitosData = dataRemitos[gridConfigs.REMITO.entityName]?.valorEsperado || [];
      setRows(remitosData);
      setIsRefetchRequired(false);
    }
  }, [dataRemitos]);

  // Manejar respuesta de Autorizaciones
  useEffect(() => {
    if (dataAutorizaciones) {
      const autorizacionesData = dataAutorizaciones[gridConfigs.AUTORIZACION.entityName]?.valorEsperado || [];
      setRows(autorizacionesData);
      setIsRefetchRequired(false);
    }
  }, [dataAutorizaciones]);

  // Manejar respuesta de Conformidades
  useEffect(() => {
    if (dataConformidades) {
      const conformidadesData = dataConformidades[gridConfigs.DEFAULT.entityName]?.valorEsperado || [];
      setRows(conformidadesData);
      setIsRefetchRequired(false);
    }
  }, [dataConformidades]);

  const handleSearch = () => {
    if (filters.fechaDesde && filters.fechaHasta && moment(filters.fechaDesde).isAfter(moment(filters.fechaHasta))) {
      toast.error("La fecha desde no puede ser mayor que la fecha hasta.");
      return;
    }
    const queryVariables = {
      filters: {
        fechaDesde: filters.fechaDesde ? moment(filters.fechaDesde).format('DD/MM/YYYY') : null,
        fechaHasta: filters.fechaHasta ? moment(filters.fechaHasta).format('DD/MM/YYYY') : null,
        idDelegacion: filters.idDelegacion,
        tipoReporte: filters.tipoReporte
      }
    };

    if (filters.tipoReporte === tipoRemitoId) {
      getRemitos({ variables: queryVariables });
    } else if (filters.tipoReporte === tipoAutorizacionId) {
      getAutorizaciones({ variables: queryVariables });
    } else {
      getConformidades({ variables: queryVariables });
    }
  };

  return {
    rows,
    setRows,
    loading: loadingRemitos || loadingAutorizaciones || loadingConformidades,
    totalCount: rows?.length || 0,
    handleSearch
  };
};